<!--续费订单详细页面-->
<template>
    <div>
        <van-sticky>
            <div style="padding: 10px 0px 0px 0px">
                <van-icon name="arrow-left" size="20px" @click="onback"/>
            </div>
        </van-sticky>
        <div class="content">
            <Card style="width:100%">
                <cell size="small" style="padding: 0px;">
                    <label>订单号：
                        <label style="color: #0077aa;">{{renewalordersDetail.orderNum}}</label>
                    </label><br/>
                </cell>

                <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{renewalordersDetail.positioningDeviceInfo.vehicleInfo.registrationNum}}</label>
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">车架号:
                                    <label style="color: #0077aa;">{{renewalordersDetail.positioningDeviceInfo.vehicleInfo.vin}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{renewalordersDetail.positioningDeviceInfo.vehicleInfo.engineNum}}</label>
                                </span>
                </div>

                <div class="mid">
                    <span class="count fl">旧服务到期时间:<label style="color: #0077aa;">{{new Date(renewalordersDetail.oldServiceDatetime).Format('yyyy年MM月dd日')}}</label></span>
                    <span class="distance fr">&nbsp;|&nbsp;</span>
                    <span class="distance fr">上次收款总金额:
                                            <label style="color: #0077aa;">{{renewalordersDetail.lastTotalAmount}}</label></span>
                </div>
                <div class="mid">
                    <span class="count fl">新服务到期时间:<label style="color: #0077aa;">{{new Date(renewalordersDetail.serviceDatetime).Format('yyyy年MM月dd日')}}</label></span>
                    <span class="distance fr">&nbsp;|&nbsp;</span>
                    <span class="distance fr">收款总金额:
                                            <label style="color: #0077aa;">{{renewalordersDetail.totalAmount}}</label></span>
                </div>
                <div class="mid">
                                        <span class="count fl">终端主机号:
                                            <label style="color: #0077aa;">{{renewalordersDetail.positioningDeviceInfo.terminalNum}}</label>
                                        </span>
                </div>
                <div class="mid">
                                        <span class="count fl">客户信息:
                                            <label style="color: #0077aa;">{{renewalordersDetail.positioningDeviceInfo.vehicleInfo.clientInfo.name+'('+(renewalordersDetail.positioningDeviceInfo.vehicleInfo.clientInfo.phoneNum)+')'}}</label>
                                        </span>
                </div>
                <div class="mid">
                                        <span class="count fl">业务跟进员:
                                            <label style="color: #0077aa;">{{renewalordersDetail.businessUser.realName}}</label>
                                        </span>
                </div>
                <div class="mid">
                                        <span class="count fl">备注:
                                            <label style="color: #0077aa;">{{renewalordersDetail.remark}}</label>
                                        </span>
                </div>
                <div class="mid" v-if="renewalordersDetail.state==1">
                    <van-button size="small" type="info"
                                @click="renewalorderconfirmservicedatetimemodal(renewalordersDetail)">确认服务期
                    </van-button>&nbsp;&nbsp;
                    <van-button size="small" type="info" @click="renewalorderrefuseservicemodal(renewalordersDetail)">
                        拒绝服务
                    </van-button>&nbsp;&nbsp;
                </div>

            </Card>
            <div style="height: 3px"></div>
            <!--                        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
            <!--                        </van-divider>-->
        </div>

        <div>
            <Modal
                    v-model="modal1"
                    title="确认续费服务期"
                    @on-ok="ok"
                    @on-cancel="cancel">
                <van-cell-group>
                    <van-field
                            readonly
                            clickable
                            required
                            :value="money"
                            @click="show = true"
                            label="总金额"
                            placeholder="请输入总金额"
                    />
                    <van-number-keyboard
                            v-model="money"
                            :show="show"
                            transition
                            extra-key="."
                            :maxlength="10"
                            @blur="show = false"
                    />
                    <van-field
                            readonly
                            required
                            clickable
                            label="日期"
                            v-model="serviceDatetime"
                            placeholder="服务到期时间"
                            @click="showPicker = true"
                    />
                    <van-popup v-model="showPicker" position="bottom">
                        <van-datetime-picker
                                v-model="currentDate"
                                :currentDate="currentDate"
                                type="date"
                                :min-date="minDate"
                                @cancel="onCancel"
                                @confirm="onConfirm(currentDate)"
                        />
                    </van-popup>


                    <van-field
                            readonly
                            clickable
                            required
                            :value="renewalOrder.billType"
                            label="开票类型"
                            placeholder="请选择类型"
                    >
                        <van-dropdown-menu slot="input">
                            <van-dropdown-item v-model="value2" :options="option2" @change="changebillType"/>
                        </van-dropdown-menu>
                    </van-field>


                    <van-field
                            v-model="renewalOrder.remark"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入备注信息"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
            <Modal
                    v-model="modal2"
                    title="拒绝服务"
                    @on-ok="ok2"
                    @on-cancel="cancel">
                <van-cell-group>
                    <van-field
                            v-model="renewalOrder2.remark"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入备注信息"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        NumberKeyboard,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(NumberKeyboard)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "renewalordersDetail",
        data() {
            return {
                renewalordersDetail: [],

                show: false,

                currentDate: new Date(),
                showPicker: false,
                minDate: new Date(),

                modal1: false,
                money:'',
                renewalOrder: {
                    id: null,
                    serviceDatetime: null,
                    billType: 1,
                    totalAmount: 0,
                    remark: ''
                },

                value2: 0,
                option2: [
                    {text: '增值税发票', value: 0},
                    {text: '增值税专用发票', value: 1},
                    {text: '增值税普通发票', value: 2},
                ],

                modal2: false,
                renewalOrder2: {
                    id: null,
                    remark: ''
                }
            }
        },
        methods: {
            changebillType() {
                if (this.value2 == 0) {
                    this.renewalOrder.billType = 1
                } else if (this.value2 == 1) {
                    this.renewalOrder.billType = 2
                } else if (this.value2 == 2) {
                    this.renewalOrder.billType = 3
                }
            },
            //日期选择开关
            onCancel() {
                this.showPicker = false
            },
            onConfirm(e) {
                this.serviceDatetime = e.Format('yyyy-MM-dd')
                this.renewalOrder.serviceDatetime = new Date(this.serviceDatetime)
                this.showPicker = false
            },
            renewalorderconfirmservicedatetimemodal(e) {
                console.log(e)
                this.modal1 = true
                this.renewalOrder.totalAmount = this.money
                this.renewalOrder.id = e.id
            },
            renewalorderrefuseservicemodal(e) {
                console.log(e)
                this.modal2 = true
                this.renewalOrder2.id = e.id
            },
            ok() {
                console.log(this.renewalOrder)
                store.dispatch('RenewalOrderServ_ConfirmServiceDatetime', {
                    params: this.renewalOrder,
                    urlparams: null
                }).then((res) => {
                    Toast('确认成功')
                }).catch((err) => {
                    Toast(err)
                })
            },
            ok2() {
                store.dispatch('RenewalOrderServ_RefuseService', {
                    params: this.renewalOrder2,
                    urlparams: null
                }).then((res) => {
                    Toast('确认成功')
                }).catch((err) => {
                    Toast(err)
                })
            },
            cancel() {
            },
            //返回上一页
            onback() {
                this.$router.push({
                    name: 'renewalorders'
                })
            },

            getCode() { // 非静默授权，第一次有弹框
                let code = this.$route.query.code
                if (!code) {
                    code = null
                }
                // window.location.href = 'https://devwxpa.jianchengjt.com/?code=' + code
                // 你自己的业务逻辑
                //微信公众服务号登录
                store.dispatch('AccountServ_LoginByWechatServiceAccount', {
                    params: {
                        wechatCode: code
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    console.log('登陆成功')
                    // this.$router.push({
                    //     name: 'orderDetails',
                    // })
                })
                    .catch((err) => {
                        console.log(err)
                        console.log('登陆失败')
                        // this.$router.push({
                        //     name: 'login',
                        // })
                    })
            },
        },
        mounted() {
            console.log(this.$route.params.renewalordersDetailid)
            let id
            if (this.$route.query.code != null) {
                this.getCode()
                id = this.$route.query.renewalordersDetailid
            } else {
                id = this.$route.params.renewalordersDetailid
            }

            store.dispatch('RenewalOrderServ_GetDetail', {
                params: {
                    id: id
                },
                urlparams: null
            }).then((res) => {
                console.log(res)
                this.renewalordersDetail = res.data
            }).catch((err) => {
                console.log(err)
            })
        }
    }
</script>

<style scoped>

</style>
